/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/metadata';
import '../common/common';
import '../../payments/set_refund_metadata';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "SetRefundMetadataRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "refundRiskReviewResult": {
                    "type": ".squareup.esperanto.common.RiskReviewResult",
                    "id": 3,
                    "rule": "optional"
                  },
                  "suppressEmailNotification": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "riskReviewerId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "riskReviewComment": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "riskReviewGeneratedDecision": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "SetRefundMetadataResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.payments.api.SetRefundMetadataResponse.Status",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.SetRefundMetadataRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.SetRefundMetadataResponse) {
  $root.addJSON(jsonData);
}

/**
 * Sets refund metadata
 *
 * SOURCE SetRefundMetadataRequest @ squareup/esperanto/api/set_refund_metadata.proto at 15:1
 */
export const SetRefundMetadataRequest = $root.lookupType('squareup.esperanto.api.SetRefundMetadataRequest');
fixType(SetRefundMetadataRequest, {
  paymentId: {
    required: true
  },
  refundUuid: {
    required: true
  }
});
Builder.createAndAttachToType(SetRefundMetadataRequest);
/**
 * SOURCE SetRefundMetadataResponse @ squareup/esperanto/api/set_refund_metadata.proto at 44:1
 */
export const SetRefundMetadataResponse = $root.lookupType('squareup.esperanto.api.SetRefundMetadataResponse');
fixType(SetRefundMetadataResponse);
Builder.createAndAttachToType(SetRefundMetadataResponse);